<template>
    <view-card headline="실측담당자">
        <v-row align="baseline">
            <v-col class="py-0">
                <v-select
                    v-model="inquiry.measurementInfo._measurer"
                    :items="[{ _id: null, name: '없음' }, ...measurers]"
                    item-text="name"
                    item-value="_id"
                    label="담당자 선택"
                    placeholder=" "
                    hide-details
                />
            </v-col>
            <v-col cols="auto" class="py-0">
                <v-btn small color="primary" @click="save">저장</v-btn>
            </v-col>
        </v-row>
    </view-card>
</template>
<script>
import api from "@/api";
import viewCard from "../dumb/view-card.vue";
export default {
    components: { viewCard },
    props: {
        value: { type: String, default: null },
        isAdmin: { type: Boolean, default: false },
    },
    data() {
        return {
            inquiry: { measurementInfo: { _measurer: null } },
            measurers: [],
        };
    },
    mounted() {
        this.init();
    },
    methods: {
        async init() {
            this.inquiry = { measurementInfo: JSON.parse(JSON.stringify({ _measurer: this.value })) };

            try {
                const { users } = await api.console.users.getUsers({ params: { scope: "measurer" } });
                this.measurers = users;
            } catch (error) {
                this.handleError(error);
            }
        },
        save() {
            this.$emit("clickSave", this.inquiry);
        },
        handleError(error) {
            console.error(error);
            alert(error.response ? error.response.data.message : error.message);
        },
    },
    watch: {
        value() {
            this.init();
        },
    },
};
</script>
